export const enum SwitchSize {
  Small = 'small',
  Default = 'default'
}
